
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Controlador as ControladorBusqueda } from '../../controlador-cursos';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        public get ControladorPrincipal() { return Model; }
        public get Controlador() { return ControladorBusqueda; }
        public get Buscador() { return ControladorBusqueda.Buscador; }

        public Estado: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Estado = this.Buscador.Estado;
            this.Eventos.push( this.Buscador.onEstado.subscribe( () => this.Estado = this.Buscador.Estado ) );

            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Filtros[key] = Number( this.Buscador.Filtros.Valores[key] );
            }

        }

        public Filtros: Record<string, number> = {
            Cuenta: 0,
            Estado: 0,
            Tipo: 0,
            Limite: 0,
            Orden: 0,
            Indice: 0,
        };

        public async Filtrar()
        {

            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Buscador.Filtros.Valores[key] = this.Filtros[key];
            }

            console.log( this.Buscador.Filtros );
            await this.Buscador.Buscar( 1 );
            this.Cerrar();
        }

        Cerrar()
        {
            this.ControladorPrincipal.Vista.SubModo = 'vacio';
        }
    }
